import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "text-heading-3"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["href", "target"]
const _hoisted_5 = { class: "w-8 h-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowButton = _resolveComponent("ArrowButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.datasets, (dataset, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "w-full flex flex-col border-b border-white mb-4"
      }, [
        (dataset.value || dataset.unit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(dataset.unit || '') + " " + _toDisplayString(dataset.value || '') + "  " + _toDisplayString(dataset.scale !== 'none' ? dataset.scale : '' || ''), 1))
          : _createCommentVNode("", true),
        (dataset.description)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "text-para-xs mb-1 text-black-100 whitespace-pre-line",
              innerHTML: dataset.description
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (dataset.link)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "mb-1 text-para-xs text-black-100 whitespace-pre-line italic inline-flex items-center",
              href: dataset.link.url,
              target: dataset.link.target
            }, [
              _createElementVNode("span", null, _toDisplayString(dataset.link.label), 1),
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_ArrowButton, {
                  direction: dataset.link.icon,
                  "zoom-level": 1
                }, null, 8, ["direction"])
              ])
            ], 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}